<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent ref="FilesList"
                      class="bg-white"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
    <b-modal v-model="isDeleteModal"
             :no-close-on-backdrop="false"
             centered title="Delete modal"
             @cancel="closeDeleteModal"
             @ok="removeItem">
      <form>
        <h3 class="text-black-50">Do you really want to delete</h3>
      </form>
    </b-modal>
  </div>
</template>

<script>
  import ListingComponent from '@/components/listing/ListingComponent';

  export default {
    name: "UsersPage",
    data () {
      return {
        id: null,
        isDeleteModal: false,
        columnConfig: [
          {
            columnCode: 'action',
            columnName: 'Action',
            value: (item) => {
              return (
                  <b-dropdown variant="link" class="listing-action">
                  <b-dropdown-item onClick={() => this.showDeleteModal(item)}>Delete</b-dropdown-item>
              </b-dropdown>
            )
            }
          },
          {
            columnCode: 'FULL_NAME',
            columnName: 'Name',
            link: '/users/edit',
            align: 'left',
            value: item => {
              return item.fullName
            }
          },
          {
            columnCode: 'EMAIL',
            columnName: 'Email',
            align: 'left',
            value: item => {
              return item.email
            }
          },
          {
            columnCode: 'PHONE',
            columnName: 'Phone',
            align: 'left',
            value: item => {
              return item.phone
            }
          },
          {
            columnCode: 'LOGIN',
            columnName: 'login',
            align: 'left',
            value: item => {
              return item.login
            }
          },
          {
            columnCode: 'INN',
            columnName: 'inn',
            align: 'left',
            value: item => {
              return item.inn
            }
          },
          {
            columnCode: 'FARM_UUID',
            columnName: 'farmUuid',
            align: 'left',
            value: item => {
              return item.farmUuid
            }
          },
          {
            columnCode: 'FIELD_UUID',
            columnName: 'fieldUuid',
            align: 'left',
            value: item => {
              return item.fieldUuid
            }
          },
          {
            columnCode: 'TELEGRAM_ID',
            columnName: 'telegramId',
            align: 'left',
            value: item => {
              return item.telegramId
            }
          },
          {
            columnCode: 'TELEGRAM_NAME',
            columnName: 'telegramName',
            align: 'left',
            value: item => {
              return item.telegramName
            }
          }
        ]
      }
    },
    methods: {
      requestProvider (payload) {
        return this.axios.get('member/list', payload)
      },
      addNewButton () {
        return (
            <router-link class="btn btn-success mr-3" to="/users/add"><i class="fas fa-plus-circle"></i></router-link>


      )
      },
      closeDeleteModal () {
        this.id = null
        this.$nextTick(() => {
          this.isDeleteModal = false
        })
      },
      showDeleteModal (item) {
        if (!item.id) {
          this.$toastr.error('Item not found')
        }
        this.id = item.id
        this.isDeleteModal = true
      },
      removeItem () {
        if (!this.id) {
          return
        }
        this.axios.delete('member/item/' + this.id )
            .then((result) => {
              this.$refs.FilesList.doRequest()
              if (result.data && result.data.status === 'success') {
                this.$toastr.success('successfully deleted')
              }
              this.isDeleteModal = false
            })
      }
    },
    components: {
      ListingComponent
    }
  }
</script>

<style scoped>

</style>